import type { ReactNode } from 'react';
import { Modal } from '../Modal';
import { ModalFooter } from '../../molecules/ModalFooter';
import * as s from './ConfirmDialog.css';

export interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<unknown>;
  title: string;
  message: string | ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'default';
  loading?: boolean;
  /** primary(확정) 버튼 비활성 — 필수 입력 미충족 등 (loading과 별개). ModalFooter primaryDisabled passthrough. */
  confirmDisabled?: boolean;
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = '확인',
  cancelLabel = '취소',
  variant = 'default',
  loading = false,
  confirmDisabled = false,
}: ConfirmDialogProps) {
  const buttonVariant = variant === 'danger' ? 'danger' : 'primary';

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <ModalFooter
          primaryVariant={buttonVariant}
          primaryLabel={confirmLabel}
          secondaryLabel={cancelLabel}
          onPrimaryClick={() => void onConfirm()}
          onSecondaryClick={onClose}
          loading={loading}
          primaryDisabled={confirmDisabled}
        />
      }
    >
      <div className={s.body}>{typeof message === 'string' ? <p>{message}</p> : message}</div>
    </Modal>
  );
}
